<template>
  <implement-page type="light" />
</template>

<script>
import ImplementPage from "@/views/space/layouts/ImplementPage.vue";

export default {
  name: "SpaceOffice",
  components: {ImplementPage}
};
</script>

<style lang="less" scoped></style>
